import React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import type { StepIconState, StepIconType } from './translation.types';

interface StepIconsProps {
  icons: StepIconState;
  nodeId: string;
  editable?: boolean;
  activeIconType?: StepIconType | null;
  onIconClicked: (nodeId: string, iconType: StepIconType) => void;
  onEditClicked?: (nodeId: string) => void;
}

export const StepIcons: React.FC<StepIconsProps> = ({
  icons,
  nodeId,
  editable = true,
  activeIconType = null,
  onIconClicked,
  onEditClicked,
}) => {
  const items: { type: StepIconType; active: boolean; className: string; label: string }[] = [
    { type: 'notes', active: icons.hasNotes, className: 'las step-notes-tab', label: 'Notes' },
    { type: 'approval', active: icons.hasApproval, className: 'las la-user', label: 'Approvers' },
    { type: 'notifications', active: icons.hasNotifications, className: 'las la-bell', label: 'Notifications' },
  ];

  return (
    <Box
      sx={{
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: 0.5,
      mt: 0.75,
      width: '100%',
      '& .step-notes-tab::before': {
        content: '"\\f249"',
      },
    }}
    >
      {items.map(({ type, active, className, label }) => {
        const selected = activeIconType === type;
        return (
          <Tooltip key={type} title={active ? label : `${label} (No details)`} arrow>
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onIconClicked(nodeId, type);
              }}
              sx={{
                p: '4px',
                color: selected ? '#2563eb' : '#6b7280',
                '&:hover': {
                  color: '#2563eb',
                  backgroundColor: 'transparent',
                },
              }}
            >
              <i className={className} aria-hidden="true" style={{ fontSize: 16, lineHeight: 1 }} />
            </IconButton>
          </Tooltip>
        );
      })}

      {editable && (
        <Tooltip title="Edit step" arrow>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onEditClicked?.(nodeId);
            }}
            sx={{
              p: '4px',
              color: '#6b7280',
              '&:hover': {
                color: '#2563eb',
                backgroundColor: 'transparent',
              },
            }}
          >
            <i className="las la-edit" aria-hidden="true" style={{ fontSize: 16, lineHeight: 1 }} />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};
  